import { FC } from 'react';

import { Icon } from '@purpur/library/icon';
import { coffee } from '@purpur/library/icon/assets/coffee';

import { RetailsTestID } from '../../test-ids';
import { WorkTimeDayLabel, WorkTimeItemContainer, WorkTimeLunch } from './SalonInfo.styles';

type Props = {
    daysLabel: string;
    openHours: string;
    lunchHours?: string;
};

export const WorkTimeItem: FC<Props> = ({ daysLabel, openHours, lunchHours }) => {
    return (
        <WorkTimeItemContainer data-test={RetailsTestID.SALON_INFO_WORK_TIME}>
            <WorkTimeDayLabel>{daysLabel}</WorkTimeDayLabel>
            <span>{openHours}</span>
            {lunchHours && (
                <WorkTimeLunch>
                    <Icon svg={coffee} size="sm" /> <span>{lunchHours}</span>
                </WorkTimeLunch>
            )}
        </WorkTimeItemContainer>
    );
};
